module.exports = "<h3 class=\"gw-titles-heading\">\n    <ng-transclude></ng-transclude>\n</h3>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/titles/templates/Heading.html
// module id = 515
// module chunks = 0